import { render, staticRenderFns } from "./BucketEdit.vue?vue&type=template&id=461baa58"
import script from "./BucketEdit.vue?vue&type=script&lang=js"
export * from "./BucketEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports